import React from 'react';

import {useDispatch} from "react-redux";

import {AppDispatch} from "../../../services/store/store";
import {useNavigate} from "react-router-dom";
import ConfirmationScreen from "../../../components/ConfirmationScreen";
import {buildUrl, FIND_YOUR_CADDIE} from "../../../services/PageUtils";

interface Props {

}

const ReviewCaddie = ({}: Props) => {

    const navigate = useNavigate();

    return (
        <ConfirmationScreen
            hideButton={true}
            submitBtnText="CONTINUE"
            submitBtnClick={() => navigate(buildUrl(FIND_YOUR_CADDIE))}
            heading="Review Complete"
            subHeading="Thank you for completing your review. This helps both the caddie and the club to ensure the caddie program is performing well."
            image={<img
                src={require('../../../images/golfClubCaddie.png')}
                style={{
                    // resizeMode: 'contain',
                    width: '75%',
                    maxHeight: 350,
                }}
             alt={"caddie holding a flag"}/>}
        />
    )
}

export default ReviewCaddie;